/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedContactSupportButton_item$ref = any;
export type PdpSharedContactSupportButton_item = {
    readonly dibsReference: string | null;
    readonly " $refType": PdpSharedContactSupportButton_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedContactSupportButton_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "dibsReference",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'fa7fd05e2a569986cf3fe8707f915d6a';
export default node;
